/**
 * An object containing a collection of cities and their respective subdistricts.
 * Each city key contains another object where the keys are subdistrict names in kebab-case and
 * the values are human-readable subdistrict names.
 *
 * @type {Object<string, Object<string, string>>}
 */
export const subdistricts = {
  warszawa: {
    aleksandrow: 'Aleksandrów',
    anin: 'Anin',
    augustowka: 'Augustówka',
    'bemowo-lotnisko': 'Bemowo-Lotnisko',
    'bialoleka-dworska': 'Białołęka Dworska',
    'bialoleka-mieszkaniowa': 'Białołęka Mieszkaniowa',
    'blonia-wilanowskie': 'Błonia Wilanowskie',
    boernerowo: 'Boernerowo',
    brodno: 'Bródno',
    'brodno-podgrodzie': 'Bródno-Podgrodzie',
    'brodno-targówek': 'Bródno-Targówek',
    brzeziny: 'Brzeziny',
    chrzanow: 'Chrzanów',
    choszczowka: 'Choszczówka',
    chomiczowka: 'Chomiczówka',
    czechowice: 'Czechowice',
    czerniakow: 'Czerniaków',
    czyste: 'Czyste',
    dabrowka: 'Dąbrówka',
    'dabrowka-szlachecka': 'Dąbrówka Szlachecka',
    elsnerow: 'Elsnerów',
    falenica: 'Falenica',
    filtry: 'Filtry',
    'fort-bema': 'Fort Bema',
    'fort-radiowo': 'Fort Radiowo',
    goclaw: 'Gocław',
    goclawek: 'Gocławek',
    golabki: 'Gołąbki',
    grabow: 'Grabów',
    gorce: 'Górce',
    grochow: 'Grochów',
    groszowka: 'Groszówka',
    groty: 'Groty',
    grodzisk: 'Grodzisk',
    henrykow: 'Henryków',
    huta: 'Huta',
    imielin: 'Imielin',
    'jeziorki-poludniowe': 'Jeziorki Południowe',
    'jeziorki-polnocne': 'Jeziorki Północne',
    'jelonki-poludniowe': 'Jelonki Południowe',
    'jelonki-polnocne': 'Jelonki Północne',
    kabaty: 'Kabaty',
    kamionek: 'Kamionek',
    kaskada: 'Kaskada',
    kaweczyn: 'Kawęczyn',
    'kaweczyn-wygoda': 'Kawęczyn-Wygoda',
    'kepa-zawadowska': 'Kępa Zawadowska',
    kepno: 'Kępno',
    klimontow: 'Klimontów',
    kobialka: 'Kobiałka',
    'kolonia-wawelberga': 'Kolonia Wawelberga',
    kolo: 'Koło',
    kopytow: 'Kopytów',
    ksawerow: 'Ksawerów',
    las: 'Las',
    'las-bielanski': 'Las Bielański',
    lotnisko: 'Lotnisko',
    'marymont-kaskada': 'Marymont-Kaskada',
    'marymont-potok': 'Marymont-Potok',
    'marymont-ruda': 'Marymont-Ruda',
    'marysin-wawerski': 'Marysin Wawerski',
    'miasteczko-wilanow': 'Miasteczko Wilanów',
    miedzeszyn: 'Miedzeszyn',
    miedzylesie: 'Międzylesie',
    milosna: 'Miłosna',
    mirow: 'Mirów',
    mloty: 'Młoty',
    mlociny: 'Młociny',
    mlynow: 'Młynów',
    muranow: 'Muranów',
    nadwisle: 'Nadwiśle',
    natolin: 'Natolin',
    niedzwiadek: 'Niedźwiadek',
    'nowa-praga': 'Nowa Praga',
    'nowe-miasto': 'Nowe Miasto',
    'nowe-wlochy': 'Nowe Włochy',
    'nowy-rembertow': 'Nowy Rembertów',
    nowodwory: 'Nowodwory',
    nowolipki: 'Nowolipki',
    odolany: 'Odolany',
    okecie: 'Okęcie',
    'olszynka-grochowska': 'Olszynka Grochowska',
    'opacz-wielka': 'Opacz Wielka',
    paluch: 'Paluch',
    pelcowizna: 'Pelcowizna',
    piaski: 'Piaski',
    placowka: 'Placówka',
    'plac-wojska-polskiego': 'Plac Wojska Polskiego',
    powsin: 'Powsin',
    powsinek: 'Powsinek',
    powazki: 'Powązki',
    powisle: 'Powiśle',
    pyry: 'Pyry',
    radiowo: 'Radiowo',
    radziwie: 'Radziwie',
    rakow: 'Raków',
    rakowiec: 'Rakowiec',
    radosc: 'Radość',
    sadul: 'Sadul',
    'sady-zoliborskie': 'Sady Żoliborskie',
    sadyba: 'Sadyba',
    salomea: 'Salomea',
    'saska-kepa': 'Saska Kępa',
    siekierki: 'Siekierki',
    sielce: 'Sielce',
    'skarpa-powsinska': 'Skarpa Powsińska',
    skorosze: 'Skorosze',
    slodowiec: 'Słodowiec',
    sluzew: 'Służew',
    sluzewiec: 'Służewiec',
    solec: 'Solec',
    'stara-milosna': 'Stara Miłosna',
    'stara-ochota': 'Stara Ochota',
    'stara-praga': 'Stara Praga',
    'stare-bielany': 'Stare Bielany',
    'stare-miasto': 'Stare Miasto',
    'stare-wlochy': 'Stare Włochy',
    'stary-imielin': 'Stary Imielin',
    'stary-mokotow': 'Stary Mokotów',
    'stary-rembertow': 'Stary Rembertów',
    'stary-sluzew': 'Stary Służew',
    'stary-zoliborz': 'Stary Żoliborz',
    stegny: 'Stegny',
    szamocin: 'Szamocin',
    szamoty: 'Szamoty',
    szczesliwice: 'Szczęśliwice',
    szmulowizna: 'Szmulowizna',
    szwederowo: 'Szwederowo',
    'srodmiescie-poludniowe': 'Śródmieście Południowe',
    'srodmiescie-polnocne': 'Śródmieście Północne',
    tarchomin: 'Tarchomin',
    'targowek-fabryczny': 'Targówek Fabryczny',
    'targowek-mieszkaniowy': 'Targówek Mieszkaniowy',
    'teren-wydzielony-rezerwat-las-kabacki': 'Teren wydzielony rezerwat "Las Kabacki"',
    ujazdow: 'Ujazdów',
    ulrychow: 'Ulrychów',
    'ursynow-centrum': 'Ursynów-Centrum',
    'ursynow-polnocny': 'Ursynów Północny',
    utrata: 'Utrata',
    // wawer: 'Wawer',
    wawrzyszew: 'Wawrzyszew',
    'wesola-centrum': 'Wesoła-Centrum',
    wierzbno: 'Wierzbno',
    'wilanow-krolewski': 'Wilanów Królewski',
    'wilanow-niski': 'Wilanów Niski',
    'wilanow-wysoki': 'Wilanów Wysoki',
    'wola-grzybowska': 'Wola Grzybowska',
    'wolka-weglowa': 'Wólka Węglowa',
    wrzeciono: 'Wrzeciono',
    wyczolki: 'Wyczółki',
    wygledow: 'Wyględów',
    zacisze: 'Zacisze',
    zaluski: 'Załuski',
    zawady: 'Zawady',
    zeran: 'Żerań',
    'zielona-grzybowa': 'Zielona-Grzybowa',
    zerzen: 'Zerzeń'
  }
};
